import styled from "styled-components";

export const ResultsBloc = styled.div`
  display: flex;
  flex-direction: column;
  padding: 56px 0;
  width: 100%;
`;

export const Separator = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.grey200};
  height: 1px;
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const EmptyResult = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 31px;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey50};
  gap: 20px;

  ul {
    margin-left: 24px;
  }

  li {
    font-family: Aileron;
    line-height: 24px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.grey600};

    a {
      color: ${({ theme }) => theme.colors.blue};
      text-decoration: underline;
      font-weight: bold;
    }
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
`;
